import React, { Fragment, useEffect } from "react";
import { Field, reduxForm } from "redux-form";
import { Typography } from "@material-ui/core";
import { TextInput, DateTimeInput } from "../forms/FormInputs";

const validate = () => {
  return {};
};

const RecordSprayActivity = ({
  title,
  timezone,
  handleSubmit,
  error,
  valid,
  pristine,
  submitting,
  isValid,
  isWaiting,
}) => {
  useEffect(() => {
    isValid(!pristine && valid && !submitting);
    isWaiting(submitting);
  });

  return (
    <Fragment>
      {title && (
        <Typography variant="h3" gutterBottom>
          {title}
        </Typography>
      )}
      <form noValidate onSubmit={handleSubmit}>
        <Field
          component={DateTimeInput}
          name="timestamp"
          id="timestamp"
          label="Timestamp"
          timezone={timezone}
        />
        <Field
          component={TextInput}
          name="chemical_name"
          id="chemical_name"
          autoFocus
          label="Chemical"
        />
        <Field
          component={TextInput}
          name="fungicide"
          id="fungicide"
          label="Amount"
        />
        <Field
          component={TextInput}
          name="active_ingredient"
          id="active_ingredient"
          label="Active Ingredient"
        />
        <Typography variant="body1" gutterBottom color="error">
          <b>{error}</b>
        </Typography>
      </form>
    </Fragment>
  );
};

export default reduxForm({ form: "RecordSprayActivity", validate })(
  RecordSprayActivity
);
